import styled from 'styled-components';
import * as S from './analysis.style';

import { useEffect, useState } from 'react';
import { NearSalesDataItem, RealSalesFilter } from '../../data';
import DetailService from '../../../../service/detail';
import UnitSwitch from '../../../../func/components/UnitSwitch';
import { useReportContext } from '../../../../context/DetailContext';
import { formatToEokMan } from '../../../../func/Function';
import Pagination from '../../../components/pagination/Pagination';

function NearRealSale() {
  const { iidx, itemType, zoning, type, exchangeItemCategory } =
    useReportContext();
  const [aroundSalesFilter, setAroundSalesFilter] = useState<RealSalesFilter>({
    iidx: Number(iidx) ?? 0,
    b_idx: 0,
    distance: 500,
    limit: 6,
    offset: 0,
    is_same1: false,
    is_same2: false,
  });

  const [totalCount, setTotalCount] = useState(0);
  const [nearSalesList, setNearSalesList] = useState<NearSalesDataItem[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pType, setPType] = useState('');
  const [unit, setUnit] = useState('평');
  const [loading, setLoading] = useState(false);

  const getNearSalesList = async (data: RealSalesFilter) => {
    setLoading(true);
    try {
      const { iidx, b_idx, distance, limit, offset, is_same1, is_same2 } = data;
      const res = await DetailService.arroundSales(
        iidx,
        b_idx,
        distance,
        limit,
        offset,
        is_same1,
        is_same2,
      );
      setNearSalesList(res.data.sale);
      setTotalCount(res.data.sale_total);
      setPType(res.data.ptype);
    } catch (e) {
      console.log('GetAroundRealDealPriceList', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (iidx !== '') {
      getNearSalesList(aroundSalesFilter);
    }
  }, [iidx, aroundSalesFilter]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);

    setAroundSalesFilter({ ...aroundSalesFilter, offset: (page - 1) * 6 });
  };

  function calculateElapsedYears(buildYear: string): number | null {
    if (!buildYear) return null;

    const currentYear = new Date().getFullYear();

    // 연도만 있는 경우 (예: "2001")
    if (/^\d{4}$/.test(buildYear)) {
      return currentYear - parseInt(buildYear, 10);
    }

    // 연,월,일 모두 있는 경우 (예: "20010331")
    if (/^\d{8}$/.test(buildYear)) {
      const year = parseInt(buildYear.slice(0, 4), 10);
      return currentYear - year;
    }

    // 지원하지 않는 형식일 경우
    return null;
  }

  if (
    aroundSalesFilter.is_same1 === false &&
    aroundSalesFilter.is_same2 === false &&
    !loading &&
    nearSalesList.length === 0
  )
    return null;
  return (
    <Container id="list-top-nearSale">
      <S.ContentTitleContainer>
        <S.TitleWrapper>
          <S.TitleBox>
            <S.TitleContent>
              <img src="/assets/images/icon/icon_sameAddress.svg" alt="" />
              <div>인근 물건 매물 가격</div>
            </S.TitleContent>
            <UnitSwitch unit={unit} setUnit={setUnit} />
          </S.TitleBox>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '6px',
            }}
          >
            {type === 'e' ? (
              <S.BlueTag>{exchangeItemCategory}</S.BlueTag>
            ) : pType ? (
              <>
                <S.BlueTag>{pType}</S.BlueTag>
                {pType === '토지' && <S.BlueTag>{zoning}</S.BlueTag>}
              </>
            ) : null}
            <S.BlueTag>
              반경{' '}
              {aroundSalesFilter.distance === 500
                ? '500m'
                : aroundSalesFilter.distance % 1000 === 0
                  ? `${aroundSalesFilter.distance / 1000}km`
                  : `${(aroundSalesFilter.distance / 1000).toFixed(1)}km`}
            </S.BlueTag>
          </div>
        </S.TitleWrapper>
        <S.CheckboxWrapper>
          <S.Checkbox
            $isOn={aroundSalesFilter.is_same1}
            onClick={() =>
              setAroundSalesFilter({
                ...aroundSalesFilter,
                is_same1: !aroundSalesFilter.is_same1,
              })
            }
          >
            <img
              src={`/assets/images/check/${aroundSalesFilter.is_same1 ? 'circle-checked-blue' : 'circle-checked-gray-outline'}.svg`}
              alt=""
            />
            동일면적 찾기
          </S.Checkbox>
          <S.Checkbox
            $isOn={aroundSalesFilter.is_same2}
            onClick={() =>
              setAroundSalesFilter({
                ...aroundSalesFilter,
                is_same2: !aroundSalesFilter.is_same2,
              })
            }
          >
            <img
              src={`/assets/images/check/${aroundSalesFilter.is_same2 ? 'circle-checked-blue' : 'circle-checked-gray-outline'}.svg`}
              alt=""
            />
            동일층수 찾기
          </S.Checkbox>
        </S.CheckboxWrapper>
      </S.ContentTitleContainer>
      <S.DistanceWrapper>
        <S.DistanceBox>
          <S.DistanceButton
            onClick={() =>
              setAroundSalesFilter({
                ...aroundSalesFilter,
                distance: 500,
              })
            }
            selectYN={aroundSalesFilter.distance === 500}
          >
            500m
          </S.DistanceButton>
          <S.DistanceButton
            onClick={() =>
              setAroundSalesFilter({
                ...aroundSalesFilter,
                distance: 1000,
              })
            }
            selectYN={aroundSalesFilter.distance === 1000}
          >
            1km
          </S.DistanceButton>
          <S.DistanceButton
            onClick={() =>
              setAroundSalesFilter({
                ...aroundSalesFilter,
                distance: 1500,
              })
            }
            selectYN={aroundSalesFilter.distance === 1500}
          >
            1.5km
          </S.DistanceButton>
          <S.DistanceButton
            onClick={() =>
              setAroundSalesFilter({
                ...aroundSalesFilter,
                distance: 2000,
              })
            }
            selectYN={aroundSalesFilter.distance === 2000}
          >
            2km
          </S.DistanceButton>
        </S.DistanceBox>
      </S.DistanceWrapper>
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          borderTop: '1px solid #E5E8EA',
        }}
      >
        <table
          style={{
            borderCollapse: 'collapse',
            width: '100%',
          }}
        >
          <thead style={{ width: '100%' }}>
            <tr>
              <S.TableHeadTh width="16%" rowSpan={1}>
                거래일
              </S.TableHeadTh>
              <S.TableHeadTh width="32%" colSpan={1}>
                금액(단가 평/m²)
              </S.TableHeadTh>
              <S.TableHeadTh width="26%" rowSpan={1}>
                전용 면적(평/m²) <br />
                (층)
              </S.TableHeadTh>
              <S.TableHeadTh width="26%" rowSpan={1}>
                거리 <br />
                (경과연수)
              </S.TableHeadTh>
            </tr>
          </thead>
          <tbody style={{ width: '100%' }}>
            {nearSalesList.length > 0 &&
              nearSalesList.map((data, index) => (
                <tr style={{ borderBottom: '1px solid #e8e9ea' }} key={index}>
                  <S.TablebodyTd width="16%">
                    {data.reg_date.split('T')[0]}
                  </S.TablebodyTd>

                  <S.TablebodyTd width="32%" style={{ textAlign: 'end' }}>
                    {(data.han_prc ?? '').trim().endsWith('억')
                      ? `${data.han_prc}원`
                      : `${data.han_prc}만원`}
                    <br></br>(
                    {unit === '평'
                      ? formatToEokMan(data.pyeong_prc)
                      : formatToEokMan(data.meter_prc)}
                    / {unit === '평' ? '평' : 'm²'})
                  </S.TablebodyTd>
                  <S.TablebodyTd width="26%">
                    {unit === '평' ? data.pyeong : data.area}
                    {unit === '평' ? '평' : 'm²'}
                    <br />({data.flr_info}
                    층)
                  </S.TablebodyTd>
                  <S.TablebodyTd width="26%">
                    {data.distance.toLocaleString()}m
                    <br />(
                    {data.build_year
                      ? `${calculateElapsedYears(data.build_year)}년`
                      : '-'}
                    )
                  </S.TablebodyTd>
                </tr>
              ))}

            {nearSalesList.length === 0 && NoDataMessage()}
          </tbody>
        </table>
      </div>
      {nearSalesList.length > 0 && (
        <Pagination
          removeMargin={true}
          currentPage={currentPage}
          totalPages={Math.ceil(Number(totalCount) / 6)}
          onPageChange={handlePageChange}
          scrollTargetId="list-top-nearSale"
        />
      )}
    </Container>
  );
}

export default NearRealSale;

function NoDataMessage() {
  return (
    <tr style={{ borderBottom: '1px solid #e8e9ea' }}>
      <S.TablebodyTd width="100%" colSpan={4}>
        최근 10년 실거래 이력이 없습니다.
      </S.TablebodyTd>
    </tr>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px;
  background: white;
`;
